import { Component, Input, Output, EventEmitter, OnChanges } from "@angular/core";

@Component({
  selector: "app-dropdown-overlay",
  templateUrl: "./dropdown-overlay.component.html",
  styleUrls: ["./dropdown-overlay.component.scss"],
})
export class DropdownOverlayComponent implements OnChanges {
  @Input() triggerText!: string; // text shown in the trigger
  @Input() options: any[] = []; // dropdown list options
  @Input() labelKey?: string; // which property to display
  @Input() translate = false; // whether to translate text
  @Input() sortKey?: string;
  @Output() optionSelected = new EventEmitter<any>();

  @Input() getOptionColor?: (option: any) => string;

  @Input() allowNullOption = false;
  @Input() nullOptionText = "Select Option";

  sortedOptions: any[] = [];
  isOpen = false;

  toggle() {
    this.isOpen = !this.isOpen;
  }

  ngOnChanges() {
    this.sortedOptions = this.sortOptions(this.options);
  }

  getLabel(option: any): string {
    if (this.labelKey && typeof option === "object") {
      return option[this.labelKey];
    }
    return option; // fallback for primitives like number/string
  }

  selectOption(opt: any) {
    this.optionSelected.emit(opt);
    this.isOpen = false;
  }

  private sortOptions(options: any[]): any[] {
    if (!this.sortKey) return options;

    return [...options].sort((a, b) => {
      const valA = (a[this.sortKey] || "").toString().toLowerCase();
      const valB = (b[this.sortKey] || "").toString().toLowerCase();
      return valA.localeCompare(valB);
    });
  }
}
